export default {
  els: document.querySelectorAll('.js-sticky-list'),
  init() {
    if (!this.els.length) return;

    this.els.forEach((el) => {
      this.update(el);

      window.addEventListener('scroll', () => {
        this.update(el);
      });

      window.addEventListener('resize', () => {
        this.update(el);
      });
    });
  },
  update(el) {
    const stickyEl = el.querySelector('.sticky-block');

    // on mobile reset sticky element and bail
    if (window.innerWidth < 992) {
      stickyEl.style = '';
      return;
    }

    // collect all necessary data
    const topnavHeight = document.querySelector('.topnav-inner').clientHeight;
    const moduleElOffsetTop =
      el.parentElement.getBoundingClientRect().top +
      window.scrollY -
      topnavHeight;
    const stickyElParent = stickyEl.parentElement;
    const stickyElOffsetTop =
      stickyElParent.getBoundingClientRect().top +
      window.scrollY -
      topnavHeight;
    const maxStickyDistance =
      stickyElParent.clientHeight - stickyEl.clientHeight;

    // update sticky element in dependency of scroll position
    if (window.scrollY <= moduleElOffsetTop) {
      // reset sticky element
      stickyEl.style = '';
    } else {
      if (window.scrollY < moduleElOffsetTop + maxStickyDistance) {
        // make sticky element sticky
        stickyEl.style.position = 'fixed';
        stickyEl.style.top = `${
          stickyElOffsetTop - moduleElOffsetTop + topnavHeight
        }px`;
        stickyEl.style.bottom = '';
        stickyEl.style.width = this.getStickyWidth(stickyElParent);
      } else {
        // position sticky element at bottom of container
        stickyEl.style.position = 'absolute';
        stickyEl.style.top = '';
        stickyEl.style.bottom = '0';
        stickyEl.style.width = this.getStickyWidth(stickyElParent);
      }
    }
  },
  getStickyWidth(stickyElParent) {
    const computedStyle = getComputedStyle(stickyElParent);
    const paddingLeft = parseFloat(computedStyle.paddingLeft);
    const paddingRight = parseFloat(computedStyle.paddingRight);
    return `${stickyElParent.clientWidth - paddingLeft - paddingRight}px`;
  },
};
